const chunkMapping = {
	"8": [
		2008
	],
	"10": [
		2010
	],
	"133": [
		4133
	],
	"230": [
		3230
	],
	"292": [
		9292
	],
	"346": [
		5346
	],
	"372": [
		5372
	],
	"408": [
		7408
	],
	"436": [
		9436
	],
	"445": [
		9826
	],
	"501": [
		9501
	],
	"593": [
		6593
	],
	"634": [
		634
	],
	"726": [
		4726
	],
	"794": [
		9794
	],
	"813": [
		2813
	],
	"830": [
		3830
	],
	"889": [
		3889
	],
	"980": [
		8980
	],
	"994": [
		1994
	]
};
const idToExternalAndNameMapping = {
	"634": [
		"default",
		"./Opportunities",
		2639
	],
	"1994": [
		"default",
		"./auditLogDashboard",
		2639
	],
	"2008": [
		"default",
		"./OpportunityTeams/count",
		2639
	],
	"2010": [
		"default",
		"./Customers/count",
		2639
	],
	"2813": [
		"default",
		"./Addresses",
		2639
	],
	"3230": [
		"default",
		"./MarketingActivities",
		2639
	],
	"3830": [
		"default",
		"./Customers",
		2639
	],
	"3889": [
		"default",
		"./ProjectSalesActivities",
		2639
	],
	"4133": [
		"default",
		"./GrappleAuditLog",
		2639
	],
	"4726": [
		"default",
		"./Opportunities/count",
		2639
	],
	"5346": [
		"default",
		"./SolutionsOffered",
		2639
	],
	"5372": [
		"default",
		"./Contacts",
		2639
	],
	"6593": [
		"default",
		"./MarketingChannels",
		2639
	],
	"7408": [
		"default",
		"./ProjectDetails",
		2639
	],
	"8980": [
		"default",
		"./ProjectDetails/count",
		2639
	],
	"9292": [
		"default",
		"./OpportunityTeams",
		2639
	],
	"9436": [
		"default",
		"./AI-Chat",
		2639
	],
	"9501": [
		"default",
		"./DeliveryModels",
		2639
	],
	"9794": [
		"default",
		"./MarketingActivities/count",
		2639
	],
	"9826": [
		"default",
		"./MarketingUseCases",
		2639
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}